import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [], light = false }) {
  const base = light ? "text-white/60 hover:text-white" : "text-ink-500 hover:text-green-700";
  const current = light ? "text-white font-semibold" : "text-ink-900 font-semibold";
  return (
    <nav aria-label="Breadcrumb" className="mono text-[11px] uppercase tracking-widest" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1.5">
        <li>
          <Link to="/" className={base}>Úvod</Link>
        </li>
        {items.map((item, i) => (
          <li key={i} className="flex items-center gap-1.5">
            <ChevronRight className="w-3 h-3 opacity-40" />
            {item.to ? (
              <Link to={item.to} className={base}>{item.label}</Link>
            ) : (
              <span className={current}>{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
